import React from 'react';
import { Switch } from 'src/components/ui/switch';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

// Generic over the form's values; the field must hold a boolean.
export const BaseFormToggleField = <T extends FieldValues>({
  control,
  name,
  label,
}: {
  control: Control<T>;
  name: Path<T>;
  label?: React.ReactNode;
}) => {
  return (
    <div className="content">
      <div className="flex items-center gap-2.5">
        <Controller
          control={control}
          name={name}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Switch defaultChecked={value} checked={value} onCheckedChange={onChange} />
          )}
        />
        {label && <p className="font-semibold text-sm text-ebony opacity-80">{label}</p>}
      </div>
    </div>
  );
};
